import { render, staticRenderFns } from "./couponGiveReceive.vue?vue&type=template&id=3ad309da&"
import script from "./couponGiveReceive.vue?vue&type=script&lang=js&"
export * from "./couponGiveReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports